import { render } from "./ContactEditor.vue?vue&type=template&id=0a6879da"
import script from "./ContactEditor.vue?vue&type=script&lang=js"
export * from "./ContactEditor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__